import { distanceBetween } from "../../Shared/utils/distanceBetween";

export function isInsideCircle(point: XY, circle: TBubbleState): boolean {
	const { center, radius } = circle;

	const dist = distanceBetween(point, center);
	const ret = dist < radius;
	return ret;
}
